import { render } from "./buttonFilterDropdown.vue?vue&type=template&id=e96a45cc"
import script from "./buttonFilterDropdown.vue?vue&type=script&lang=js"
export * from "./buttonFilterDropdown.vue?vue&type=script&lang=js"
script.render = render

export default script